module.exports = __webpack_public_path__ + "static/95175420-ded9-4ff2-b34a-56a1b50b7437-350.950f03e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/st-pirans-chapel-trevethy-tintagel/95175420-ded9-4ff2-b34a-56a1b50b7437-350.jpg
// module id = 1224
// module chunks = 168707334958949